import axios from "../../utils/axiosConfig.js";
import { server } from "../../server/server";

// Get all stores items - aggregated view across all stores
export const getAllStoresItems = () => async (dispatch) => {
    try {
        dispatch({ type: "getAllStoresItemsRequest" });

        const { data } = await axios.get(`${server}/store-inventory/get-all-stores-items`, {
            withCredentials: true,
        });

        dispatch({
            type: "getAllStoresItemsSuccess",
            payload: data.items,
        });
    } catch (error) {
        dispatch({
            type: "getAllStoresItemsFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Get single store items - dedicated action for single store view
export const getSingleStoreItems = (storeId) => async (dispatch) => {
    try {

        dispatch({ type: "getSingleStoreItemsRequest" });

        const { data } = await axios.get(`${server}/store-inventory/get-single-store-items/${storeId}`, {
            withCredentials: true,
        });

        dispatch({
            type: "getSingleStoreItemsSuccess",
            payload: data.items,
        });
    } catch (error) {
        dispatch({
            type: "getSingleStoreItemsFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Create Inventory Item
export const createInventoryItem = (newItem) => async (dispatch) => {
    try {
        dispatch({ type: "createInventoryItemRequest" });

        const { data } = await axios.post(`${server}/store-inventory/create-item`, newItem, {
            withCredentials: true,
        });

        dispatch({
            type: "createInventoryItemSuccess",
            payload: data.item,
        });

        // Refresh the inventory list after creation
        dispatch(getSingleStoreItems(newItem.store));
    } catch (error) {
        dispatch({
            type: "createInventoryItemFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Edit Store Inventory Item
export const editStoreInventoryItem = (id, updatedData) => async (dispatch) => {
    try {
        dispatch({ type: "editStoreInventoryItemRequest" });

        const { data } = await axios.put(`${server}/store-inventory/update-item/${id}`, updatedData, {
            withCredentials: true,
        });

        dispatch({
            type: "editStoreInventoryItemSuccess",
            payload: data.item,
        });

        // Refresh the inventory list after update
        dispatch(getInventoryItemDetails(id));
        dispatch(getSingleStoreItems(data.item.store));
    } catch (error) {
        dispatch({
            type: "editStoreInventoryItemFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Get Inventory Item Details
export const getInventoryItemDetails = (id) => async (dispatch) => {
    try {
        dispatch({ type: "getInventoryItemDetailsRequest" });

        const { data } = await axios.get(`${server}/store-inventory/get-item-details/${id}`, {
            withCredentials: true,
        });

        dispatch({
            type: "getInventoryItemDetailsSuccess",
            payload: data.item,
        });
    } catch (error) {
        dispatch({
            type: "getInventoryItemDetailsFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Add Inventory Quantity to an Item
export const addInventoryQuantity = (id, inventoryData) => async (dispatch) => {
    try {
        dispatch({ type: "addInventoryQuantityRequest" });

        const { data } = await axios.put(`${server}/store-inventory/add-quantity/${id}`, inventoryData, {
            withCredentials: true,
        });

        dispatch({
            type: "addInventoryQuantitySuccess",
            payload: data.item,
        });

        // Refresh the inventory list after addition
        dispatch(getInventoryItemDetails(id));

    } catch (error) {
        dispatch({
            type: "addInventoryQuantityFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Remove Inventory Quantity from an Item
export const removeInventoryQuantity = (id, quantity) => async (dispatch) => {
    try {
        dispatch({ type: "removeInventoryQuantityRequest" });

        const { data } = await axios.put(`${server}/store-inventory/remove-quantity/${id}`, { quantity }, {
            withCredentials: true,
        });

        dispatch({
            type: "removeInventoryQuantitySuccess",
            payload: data.item,
        });

    } catch (error) {
        dispatch({
            type: "removeInventoryQuantityFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Deduct Inventory Quantity from an Item
export const deductInventoryQuantity = (id, deductData) => async (dispatch) => {
    try {
        dispatch({ type: "deductInventoryQuantityRequest" });

        const { data } = await axios.put(`${server}/store-inventory/deduct-quantity/${id}`, deductData, {
            withCredentials: true,
        });

        dispatch({
            type: "deductInventoryQuantitySuccess",
            payload: data.item,
        });

        // Refresh the inventory item details after deduction
        dispatch(getInventoryItemDetails(id));

    } catch (error) {
        dispatch({
            type: "deductInventoryQuantityFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Transfer Inventory Item
export const transferInventoryItem = (id, transferData) => async (dispatch) => {
    try {
        dispatch({ type: "transferInventoryItemRequest" });

        const { data } = await axios.put(`${server}/store-inventory/transfer-item/${id}`, transferData, {
            withCredentials: true,
        });

        dispatch({
            type: "transferInventoryItemSuccess",
            payload: data.item,
        });

    } catch (error) {
        dispatch({
            type: "transferInventoryItemFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Delete Inventory Item
export const deleteInventoryItem = (id, storeId) => async (dispatch) => {
    try {
        dispatch({ type: "deleteInventoryItemRequest" });

        const { data } = await axios.delete(`${server}/store-inventory/delete-item/${id}`, {
            withCredentials: true,
        });

        dispatch({
            type: "deleteInventoryItemSuccess",
            payload: data.message,
        });

        dispatch(getSingleStoreItems(storeId));
    } catch (error) {
        dispatch({
            type: "deleteInventoryItemFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Get store inventory value based on the total quantity and buying price
export const getInventoryValue = () => async (dispatch) => {
    try {
        dispatch({ type: "getInventoryValueRequest" });

        const { data } = await axios.get(`${server}/store-inventory/store-inventory-value`, {
            withCredentials: true,
        });

        dispatch({
            type: "getInventoryValueSuccess",
            payload: data.inventoryValue,
        });
    } catch (error) {
        dispatch({
            type: "getInventoryValueFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Activate or Deactivate Store Inventory Item
export const toggleInventoryItemStatus = (id, storeId) => async (dispatch) => {
    try {
        dispatch({ type: "toggleInventoryItemStatusRequest" });

        const { data } = await axios.put(`${server}/store-inventory/toggle-item-status/${id}`, {}, {
            withCredentials: true,
        });

        dispatch({
            type: "toggleInventoryItemStatusSuccess",
            payload: data.item,
        });
        // Refresh the inventory list after status change
        dispatch(getSingleStoreItems(storeId));

    } catch (error) {
        dispatch({
            type: "toggleInventoryItemStatusFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Delete Inventory Activity
export const deleteInventoryActivity = (itemId, activityIndex) => async (dispatch) => {
    try {
        dispatch({ type: "deleteInventoryActivityRequest" });

        const { data } = await axios.delete(`${server}/store-inventory/delete-activity/${itemId}/${activityIndex}`, {
            withCredentials: true,
        });

        dispatch({
            type: "deleteInventoryActivitySuccess",
            payload: data.item,
        });

        // Refresh the inventory item details after deletion
        dispatch(getInventoryItemDetails(itemId));

    } catch (error) {
        dispatch({
            type: "deleteInventoryActivityFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Delete Reconciliation Record
export const deleteReconciliationRecord = (itemId, recordIndex) => async (dispatch) => {
    try {
        dispatch({ type: "deleteReconciliationRecordRequest" });

        const { data } = await axios.delete(`${server}/store-inventory/delete-reconciliation/${itemId}/${recordIndex}`, {
            withCredentials: true,
        });

        dispatch({
            type: "deleteReconciliationRecordSuccess",
            payload: data.item,
        });

        // Refresh the inventory item details after deletion
        dispatch(getInventoryItemDetails(itemId));
    } catch (error) {
        dispatch({
            type: "deleteReconciliationRecordFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// reconcile inventory
export const reconcileInventory = (id, reconciliationData) => async (dispatch) => {
    try {
        dispatch({ type: "reconcileInventoryRequest" });

        const { data } = await axios.put(`${server}/store-inventory/reconcile-inventory/${id}`, reconciliationData, {
            withCredentials: true,
        });

        dispatch({
            type: "reconcileInventorySuccess",
            payload: data.item,
        });

        // Refresh the inventory list after reconciliation
        dispatch(getInventoryItemDetails(id));

    } catch (error) {
        dispatch({
            type: "reconcileInventoryFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Clear Errors
export const clearErrors = () => (dispatch) => {
    dispatch({ type: "clearErrors" });
};

// Clear Success Messages
export const clearSuccess = () => (dispatch) => {
    dispatch({ type: "clearSuccess" });
};

// Clear All Stores Items
export const clearAllStoresItems = () => (dispatch) => {
    dispatch({ type: "clearAllStoresItems" });
};

// Clear Single Store Items
export const clearSingleStoreItems = () => (dispatch) => {
    dispatch({ type: "clearSingleStoreItems" });
};
